import { render, staticRenderFns } from "./order-manag.vue?vue&type=template&id=cc595a6c&"
import script from "./order-manag.vue?vue&type=script&lang=js&"
export * from "./order-manag.vue?vue&type=script&lang=js&"
import style0 from "./order-manag.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports